import { MyteamsComponent } from './myteams/myteams.component';
import { ResponsibleComponent } from './pages/responsible/responsible.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes} from '@angular/router';
import { HomeComponent } from './home';
import { LoginComponent } from './login';
import { RegisterComponent } from './register';
import { AuthGuard,UnSavedGuard } from './_guards';
import { MobileInfoboxComponent } from './components/mobile-infobox/mobile-infobox.component';
import { OwnershipComponent } from './pages/ownership/ownership.component';
import { LobbyComponent } from './lobby/lobby.component';
import { RankingsComponent } from './rankings/rankings.component';
import { TiersComponent } from './tiers/tiers.component';
import { Draft2Component } from './draft2/draft2.component';
import { NfpageComponent } from './newsfeed/nfpage.component';
import { MessagesComponent } from './messages/messages.component';
import { PropsComponent } from './props/props.component';
import { MyteamComponent } from './props/myteam/myteam.component';
import { UsersComponent } from './users/users.component';
import { RankemComponent } from './rankem/rankem.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { RedirectToNewAppGuard } from './_guards/redirect-to-new-app.guard';
import { DraftAccessGuard } from './_guards/draft_access.guards';
import { MyTeamsAccessGuard } from './_guards/myTeams-access.guard';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  //{ path: 'ownership/:game_type', component: OwnershipComponent },
  // { path: 'responsible', component: ResponsibleComponent },
  { path: 'player/app-infobox/:player_id/:league_id/:season_id', component: MobileInfoboxComponent },
  //  { path: 'lobby', component: LobbyComponent },
  // { path: 'rankings', component: RankingsComponent },
  { path: 'tiers/:league_id', component: TiersComponent },
  { path: 'tiers/:league_id/:lgm_id', component: TiersComponent },
  { path: 'myteams', component: MyteamsComponent , canActivate: [AuthGuard,MyTeamsAccessGuard]},
  { path: 'draft/:league_id', component: Draft2Component, canActivate: [AuthGuard,DraftAccessGuard] },
  //  { path: 'news', component: NfpageComponent},
  // { path: 'messages', component: MessagesComponent },
  // { path: 'messages/:drafters_id', component: MessagesComponent },
  // { path: 'props', component: PropsComponent },
  // { path: 'props/:game_type', component: PropsComponent },
  // { path: 'props-myteams/:mode', component: MyteamComponent },
  { path: 'users', component: UsersComponent },
  // { path: 'user/refer-friend', component: UsersComponent },
  { path: 'rankem/:game_type/:league_id', component: RankemComponent,canDeactivate:[UnSavedGuard] }, // need to be removed
  { path: 'rankem/:game_type/:league_id/:lgm_id', component: RankemComponent,canDeactivate:[UnSavedGuard] },
  // otherwise redirect to home
  // { path: '**', redirectTo: '' },
  { path: 'resultboard', loadChildren: './resultboard/resultboard.module#ResultboardModule', canActivate: [AuthGuard] },
  //{ path: 'register/welcome', component: WelcomeComponent },
  // { path: 'lobby', loadChildren: './lobby/lobby.module#LobbyModule' }
   {
    path: '**',
    canActivate: [RedirectToNewAppGuard],
    component: HomeComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }


/*
Copyright 2017-2018 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/
